module.exports = function($) {
  return $.fn.ready = (function(proceed) {
    return function(unsafe) {
      var safely;
      safely = function() {
        var e, err, msg;
        try {
          return unsafe.apply(this, arguments);
        } catch (error) {
          e = error;
          msg = 'Exception in a jQuery.ready callback: ';
          if (window.console && typeof console.error === 'function') {
            console.error(msg, e);
          } else {
            err = new Error(msg + e.message);
            err.original = e;
            setTimeout((function() {
              throw err;
            }), 0);
          }
        }
      };
      return proceed(safely);
    };
  })($.fn.ready);
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2FyaWNodGVyL3JlcG9zaXRvcmllcy9zbHMvc3JjL2Zyb250ZW5kL2NvcmUvanF1ZXJ5LnNhZmUtcmVhZHkuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL1VzZXJzL2FyaWNodGVyL3JlcG9zaXRvcmllcy9zbHMvc3JjL2Zyb250ZW5kL2NvcmUvanF1ZXJ5LnNhZmUtcmVhZHkuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUdBLE1BQU0sQ0FBQyxPQUFQLEdBQWlCLFNBQUMsQ0FBRDtTQUVmLENBQUMsQ0FBQyxFQUFFLENBQUMsS0FBTCxHQUFnQixDQUFBLFNBQUMsT0FBRDtXQUdkLFNBQUMsTUFBRDtBQUdFLFVBQUE7TUFBQSxNQUFBLEdBQVMsU0FBQTtBQUNQLFlBQUE7QUFBQTtBQUNFLGlCQUFPLE1BQU0sQ0FBQyxLQUFQLENBQWEsSUFBYixFQUFtQixTQUFuQixFQURUO1NBQUEsYUFBQTtVQUVNO1VBQ0osR0FBQSxHQUFNO1VBQ04sSUFBRyxNQUFNLENBQUMsT0FBUCxJQUFtQixPQUFPLE9BQU8sQ0FBQyxLQUFmLEtBQXdCLFVBQTlDO1lBQ0UsT0FBTyxDQUFDLEtBQVIsQ0FBYyxHQUFkLEVBQW1CLENBQW5CLEVBREY7V0FBQSxNQUFBO1lBR0UsR0FBQSxHQUFVLElBQUEsS0FBQSxDQUFNLEdBQUEsR0FBTSxDQUFDLENBQUMsT0FBZDtZQUNWLEdBQUcsQ0FBQyxRQUFKLEdBQWU7WUFDZixVQUFBLENBQVcsQ0FBRSxTQUFBO0FBQUcsb0JBQU07WUFBVCxDQUFGLENBQVgsRUFBNkIsQ0FBN0IsRUFMRjtXQUpGOztNQURPO2FBY1QsT0FBQSxDQUFRLE1BQVI7SUFqQkY7RUFIYyxDQUFBLENBQUgsQ0FBYyxDQUFDLENBQUMsRUFBRSxDQUFDLEtBQW5CO0FBRkUifQ==
